import styled from 'styled-components';

export const SalaryUpdateContainer = styled.div`
    background: ${({theme}) => theme.white};
    border-radius: 8px;
    border: 1px solid ${({theme}) => theme.grayDivider};
    display: flex;
    align-items: flex-start;
    padding: 32px;
    margin-bottom: 30px;
`

export const SalaryUpdateActions = styled.div`
    display: flex;
    flex-direction: column;
`

export const SalaryUpdateTitle = styled.h3`
  color: ${({theme}) => theme.black};
  font-size: 19px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  letter-spacing: 0.4px;
  margin-bottom: 10px;
`

export const SalaryUpdateMessage = styled.p`
  color: ${({theme}) => theme.gray};;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.3px;
  margin-bottom: 15px;
`
export const SalaryIcon = styled.div`
    margin-right: 20px;
      @media (max-width: ${({theme}) => theme.breakpoints.md}) {
        display: none;
      }
`

export const SalaryUpdateButtonContainer = styled.div`
  display: flex;
  > button:first-child{
    margin-right: 30px;
  }
  @media (max-width: ${({theme}) => theme.breakpoints.md}) {
    flex-direction: column;
    > button:first-child{
      margin-left: 0;
      margin-bottom: 10px;
    }
  }
`

